const Gateway = {
  initial: true,
  getData: function(offset, filters) {
    const count = this.initial ? 6 : 10
    const data = this.pullData(offset, filters)
    const rest = data.length - count < 0 ? data.length : count

    this.initial = false
    
    return Promise.resolve(data.splice(offset, rest))
  },
  pullData: function(offset, filters) {
    filters = filters || {}
    offset  = offset || 0
    
    let copy = [].concat(window.iron_careers.data)

    return copy.filter(item => {
      for (let i in filters) {
        if (!filters[i].length)
          continue

        if (!filters[i].filter(value => -1 !== item[i].indexOf(value)).length)
          return false
      }

      return item
    })
  },
  getFilters: function() {
    return Promise.resolve(window.iron_careers.filters.data)
  }
}

export default Gateway